import { combineReducers } from 'redux'
import selected from './get-one'
import all from './get-all'
import newOne from './new'
import editOne from './edit'
import deleteOne from './delete'
import editResponsibles from './edit-customer-responsibles'
import updateCurrentCustomer from './update-current-customer'
import downloadCustomer from './download-customer'

const reducer = combineReducers({
  selected,
  all,
  newOne,
  editOne,
  editResponsibles,
  deleteOne,
  updateCurrentCustomer,
  downloadCustomer,
})

export default reducer
